// ContactHero.js
import React from 'react';
import { Link } from 'react-router-dom';

const ContactHero = () => {
  return (
    <section className="bg-bnCream pt-16 pb-16 md:pt-24 md:pb-20">
      <div className="max-w-5xl mx-auto px-6 text-center">
        {/* Breadcrumb */}
        <div className="flex items-center justify-center gap-2 text-sm text-bnBody mb-8">
          <Link to="/" className="hover:text-bnAccent transition-colors">
            Home
          </Link>
          <span className="text-bnBorder">|</span>
          <span className="text-bnInk">Contact</span>
        </div>

        <p className="text-bnAccent text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-5">
          Get In Touch
        </p>
        <h1 className="font-display font-light text-bnInk leading-[1.1] text-4xl md:text-5xl mb-5">
          Contact Us Today
        </h1>
        <p className="text-bnBody text-base md:text-lg leading-relaxed max-w-2xl mx-auto">
          We are proud to support families across Canberra and the wider ACT, including Weston and the surrounding suburbs throughout the Australian Capital Territory.
        </p>
      </div>
    </section>
  );
};

export default ContactHero;
